<!-- <p>badminton-tournament works!</p> -->

<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Bhandara One-Day Rapid Chess Tournament</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>G. H. Memorial Bhandara One-Day <span>Rapid Chess Tournament </span></h2>
        </div>

        <div class="row text-justify">
            <div class="col-lg-12">
                <p>
                    The G. H. Memorial Bhandara One-Day Rapid Chess Tournament was successfully held on
                    February 23, 2025, at Badge Celebration Hall, Lakhani, attracting players from various
                    districts, including Nagpur, Bhandara, Chandrapur, Gadchiroli, Gondia, and Rajnandgaon.
                    A total of 42 internationally ranked players participated, making the competition intense and
                    exciting.
                </p>
                <p>In the overall category, Shaunak Badole from Nagpur secured the first position, followed by
                    Sparsh Khandelwal from Rajnandgaon in second place and Siddhant Tayade from Nagpur
                    in third. In the Unrated category, Arun Tumsare clinched the top spot, while Simran Tijare
                    and Pankaj Bhitre from Bhandara secured second and third places, respectively. Among the
                    seniors, Sanjay Bhange from Nagpur emerged as the winner, with D. B. Chaure from Gondia
                    finishing second and Pramod Ramteke from Nagpur securing third place.</p>
                <p>The tournament also recognized young talents across different age groups. In the Under-7
                    category, Faizan Pathan took first place, followed by Shripad Dhenge. The Under-9 boys &
                    category saw Vihaan Lanje emerging as the winner, while Dhvanit Mawale finished second.
                    In the Under-9 girls & category, Mansvi Pandya secured first place, with Urvi Gugal taking the
                    second spot. Moving to the Under-11 boys &  category, Parish Kubde finished first, followed by
                    Nirbhay Gabhane in second place, while in the Under-11 girls & category, Avani Bhope
                    secured the top position, with Jivika Ramteke as the runner-up.</p>
                <p>In the Under-13 boys & category, Haresh Aswani took first place, while Abhas Mohture
                    finished second. Among the Under-13 girls, Asad Jafira won first place, with Janhavi
                    Chuttani securing second place. The Under-15 boys & category saw Krish Dharamsare
                    clinching first place, followed by Rudra Dhole in second place, while in the Under-15 girls &
                    category, Pariniti Arade secured first place, and Riya Deshmukh finished second. In the
                    Under-19 boys & category, Rohit Lanjewar took first place, with Darshil Deshbhartar coming
                    in second, while in the Under-19 girls & category, Siddhi Bhope finished first, followed by Isha
                    Lichade in second place.</p>
                <p>Additionally, Advik Sukhdeve was recognized as the youngest male player, while Tanishka
                    Aswani was honored as the youngest female player in the tournament. All participants were
                    awarded cash prizes worth ₹30,000, along with trophies and medals in recognition of their
                    performances.</p>
                <p>The event was graced by distinguished guests, including Dr. Vijay Niranjane, President of the
                    Classic & Rapid Chess Circle Association, Bhandara, Bhushan Shriwas, Secretary of the
                    Kalpana Prakash Welfare Foundation, Nagpur, and esteemed personalities Suresh Sakhare
                    and Babita Sakhare. The tournament was officiated by International Chess Arbiter FA Sagar
                    Sakhare, with assistance from Prayas Ambade and Prathamesh Machave. The dignitaries
                    extended their heartfelt congratulations to all the participants and wished them great success in
                    their future endeavors.</p>

                </div>


        </div>



    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
									View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
							</a> -->
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">

                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-1.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-1.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-1.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-2.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-2.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-2.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-3.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-3.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-3.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-4.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-4.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-4.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-5.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-5.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-5.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-6.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-6.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-6.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
									View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
							</a> -->
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-7.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-7.avif"
                            >
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/bhan-oneday-rapid-chess-7.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
